import { Link } from "react-router-dom";

function CountriesByAlphabet(props) {
    return(
        <article className="column">
            <h2 className="subtitle is-size-two">{ props.letter }</h2>
            {
                props.countries.map((country, index) => {
                    const hrefStr = "/view/" + country;
                    return(
                        <div key={index}><Link to={hrefStr}>{ country }</Link></div>
                    )
                })
            }
        </article>
    )
}

export default CountriesByAlphabet;